import Input from 'component/atom/forms/input/input/Input';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import { categoriesToast } from 'helpers/toastMessages';
import { categoriesEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import React, { useEffect } from 'react';
import styles from './AddCategory.module.scss';
import * as Yup from 'yup';
import TextArea from 'component/atom/forms/text-area/TextArea';
import { useToast } from 'app-context/toasterContext/ToastContext';

const Form = ({ formik }) => (
  <form autoComplete='off' onSubmit={formik.handleSubmit} className='formCont'>
    <Input
      label='Name'
      placeholder='Enter Subcategory Name'
      name='CategoryName'
      value={formik.values.CategoryName}
      onChange={formik.handleChange}
      error={formik.errors.CategoryName}
      touched={formik.touched.CategoryName}
      inputContainerClassName={styles.input}
    />
    <TextArea
      label='Description'
      placeholder='Enter Description'
      name='Description'
      value={formik.values.Description}
      onChange={formik.handleChange}
      error={formik.errors.Description}
      touched={formik.touched.Description}
    />
  </form>
);

const AddSubCategory = ({ isOpen, onClose, botId, item, refetch, mode }) => {
  const { mutate: AddCategory, isPending } = usePost({
    onSuccessToast:
      mode === 'edit' || mode === 'edit-sub'
        ? categoriesToast.update
        : categoriesToast.add,
    toastType: 'add',
  });

  const isEdit = mode === 'edit' || mode === 'edit-sub';
  const isAddSub = mode === 'add-sub';
  const toast = useToast();

  const formik = useFormik({
    initialValues: {
      CategoryName: isEdit ? item?.categoryText : '',
      Description: isEdit ? item?.description || '' : '',
    },
    validationSchema: Yup.object({
      CategoryName: Yup.string().required('Subcategory name is Required'),
      Description: Yup.string().required('Description is Required'),
    }),
    onSubmit: (values, { resetForm }) => {
      const payload = {
        categoryName: values.CategoryName,
        description: values.Description,
        botId,
      };

      if (mode === 'edit-sub') {
        payload.categoryId = item?.categoriesId;
        payload.parentId = item?.parentId; // ✅ preserve parent relationship
      } else if (mode === 'edit') {
        payload.categoryId = item?.categoriesId;
      } else if (mode === 'add-sub') {
        payload.parentId = item?.categoriesId; // parent category ID
      }

      AddCategory(
        {
          url: categoriesEndpoints.createCategory(),
          data: payload,
        },
        {
          onSuccess: (e) => {
            if (!e?.data?.result?.isSuccess) {
              toast.open(e?.data?.result?.userMessage, 'delete');
              return;
            }
            refetch();
            onClose();
            resetForm();
          },
        },
      );
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);

  const getTitle = () => {
    if (mode === 'add') return 'Add Category';
    if (mode === 'edit') return 'Edit Category';
    if (mode === 'add-sub') return 'Add Subcategory';
    if (mode === 'edit-sub') return 'Edit Subcategory';
    return 'Category';
  };

  return (
    <Modal
      title={getTitle()}
      isOpen={isOpen}
      onClose={onClose}
      modalContent={{ component: <Form formik={formik} /> }}
      onSubmit={formik.handleSubmit}
      buttonType='submit'
      onSubmitstyles={{ onSubmit: { label: 'Save' } }}
      isLoading={isPending}
    />
  );
};

export default AddSubCategory;
